import { apiClient } from './api';

interface CheckInResponse {
  message: string;
}

export const checkinService = {
  async checkIn(): Promise<CheckInResponse> {
    const { data } = await apiClient.patch<CheckInResponse>('/api/v1/check-in');
    return data;
  },
};
